import { connect } from 'react-redux';
import { getScanHistory, resetPage } from '../../actions/ScanHistoryPage';
import ScanHistoryPage from './ScanHistoryPage';

const mapsStateToProps = state => ({
	scanHistoryPageProps: state.scanHistoryPageReducer
});

const mapsDispatchToProps = dispatch => ({
	getScanHistory(options) {
		dispatch(getScanHistory(options));
	},
	resetPage() {
		dispatch(resetPage());
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(ScanHistoryPage);
